export function meetingProviderLabel(provider) {
  return provider === "google_meet" ? "Google Meet" : "Zoom";
}
